import { AxiosResponse } from "axios";
import { RefuelFieldsModel } from "../../type/entities/refuel-type";
import { RestServiceConnection } from "../restServiceConnection";

const REFUELS_ENDPOINT = "/refuel";

export class RefuelService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE REPOSTAJES
     * @EN GETS THE LIST OF REFUELS
     */
    // -------------------------------------------------------------------------------------------------------------
    listRefuels = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN REPOSTAJES POR SU ID
     * @EN GETS A REFUEL BY ITS ID
     */
    // -------------------------------------------------------------------------------------------------------------
    getRefuelById = async (refuelId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/get",
            data: { id: refuelId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE REPOSTAJES POR VEHÍCULO
     * @EN GETS REFUELS BY VEHICLE
     */
    // -------------------------------------------------------------------------------------------------------------
    getRefuelsByVehicle = async (vehicleId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/by-vehicle",
            data: { vehicleId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE REPOSTAJES POR USUARIO
     * @EN GETS REFUELS BY USER
     */
    // -------------------------------------------------------------------------------------------------------------
    getRefuelsByUser = async (userId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/by-user",
            data: { userId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN REPOSTAJE
     * @EN CREATES A REFUEL
     */
    // -------------------------------------------------------------------------------------------------------------
    createRefuel = async (refuel: FormData) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/create",
            data: refuel,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UN REPOSTAJE
     * @EN EDITS A REFUEL
     */
    // -------------------------------------------------------------------------------------------------------------
    editRefuel = async (refuel: RefuelFieldsModel & { id: string }) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/edit",
            data: refuel,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN REPOSTAJE
     * @EN DELETES A REFUEL
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteRefuel = async (refuelId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/delete",
            data: { id: refuelId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA MÚLTIPLES REPOSTAJES
     * @EN DELETES MULTIPLE REFUELS
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiRefuel = async (refuelIds: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/delete-multi",
            data: { ids: refuelIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE ESTADÍSTICAS DE REPOSTAJES
     * @EN GETS REFUEL STATISTICS
     */
    // -------------------------------------------------------------------------------------------------------------
    getRefuelStatistics = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/statistics",
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE COSTO TOTAL POR VEHÍCULO
     * @EN GETS TOTAL COST BY VEHICLE
     */
    // -------------------------------------------------------------------------------------------------------------
    getTotalCostByVehicle = async (vehicleId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/total-cost-by-vehicle",
            data: { vehicleId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE TOTAL DE LITROS POR VEHÍCULO
     * @EN GETS TOTAL LITERS BY VEHICLE
     */
    // -------------------------------------------------------------------------------------------------------------
    getTotalLitersByVehicle = async (vehicleId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/total-liters-by-vehicle",
            data: { vehicleId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE PRECIO PROMEDIO POR LITRO POR VEHÍCULO
     * @EN GETS AVERAGE PRICE PER LITER BY VEHICLE
     */
    // -------------------------------------------------------------------------------------------------------------
    getAveragePricePerLiterByVehicle = async (vehicleId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/average-price-per-liter-by-vehicle",
            data: { vehicleId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE DOCUMENTOS POR REPOSTAJE
     * @EN GETS DOCUMENTS BY REFUEL
     */
    // -------------------------------------------------------------------------------------------------------------
    getDocumentsByRefuel = async (refuelId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/get-documents",
            data: { refuelId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN DOCUMENTO DE UN REPOSTAJE
     * @EN DELETES A DOCUMENT FROM A REFUEL
     */
    // -------------------------------------------------------------------------------------------------------------
    removeRefuelDocument = async (refuelId: string, documentIds: Array<string>) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/remove-document",
            data: { refuelId, documentIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EXPORTA REPOSTAJES A EXCEL
     * @EN EXPORTS REFUELS TO EXCEL
     */
    // -------------------------------------------------------------------------------------------------------------
    exportRefuels = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/export",
            data: filters,
            responseType: "blob",
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES IMPORTA REPOSTAJES DESDE UN EXCEL
     * @EN IMPORTS REFUELS FROM AN EXCEL FILE
     */
    // -------------------------------------------------------------------------------------------------------------
    importExcel = async (formData: FormData) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/import",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA TODOS LOS REPOSTAJES
     * @EN DELETES ALL REFUELS
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteAllRefuels = async (companyId?: string | null) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: REFUELS_ENDPOINT + "/delete-all",
            data: companyId ? { company: companyId } : {},
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}